<template>
	<PartialsSideButtons
		#default="defaultProps"
		v-model="vModel"
		icon-left="minus"
		icon-right="plus"
		:removable="removable"
		:light-theme="lightTheme"
		:is-loading="isLoading"
		:disabled="disabled"
		:label-left="labelLeft"
		:label-right="labelRight"
		:full-width="fullWidth"
		:icon-button-style="iconButtonStyle"
		:remove-icon-class="removeIconClass"
		:button-size-class="buttonSizeClass"
		@remove="emit('remove')"
	>
		<slot v-bind="defaultProps" />
	</PartialsSideButtons>
</template>

<script setup lang="ts">
	interface Props {
		modelValue: number
		removable?: boolean
		lightTheme?: boolean
		isLoading?: boolean
		disabled?: boolean
		labelLeft?: string
		labelRight?: string
		fullWidth?: boolean
		iconButtonStyle?: boolean
		removeIconClass?: string
		buttonSizeClass?: string
	}

	interface Emits {
		(e: 'update:modelValue', payload: number): void
		(e: 'remove'): void
	}

	const props = defineProps<Props>();
	const emit = defineEmits<Emits>();
	const vModel = useVModel(props, 'modelValue', emit);
</script>
